const ScannerTypeAdminIconSubcategory = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2141_25696)" />
      <path
        d="M25.8333 20C22.6117 20 20 22.6117 20 25.8333V28.9394C20 29.8599 20.7462 30.6061 21.6667 30.6061C22.5871 30.6061 23.3333 29.8599 23.3333 28.9394V25.8333C23.3333 24.4526 24.4526 23.3333 25.8333 23.3333H28.9394C29.8599 23.3333 30.6061 22.5871 30.6061 21.6667C30.6061 20.7462 29.8599 20 28.9394 20H25.8333ZM41.0607 20C40.1402 20 39.394 20.7462 39.394 21.6667C39.394 22.5871 40.1402 23.3333 41.0607 23.3333H44.1667C45.5473 23.3333 46.6667 24.4526 46.6667 25.8333V28.9394C46.6667 29.8599 47.4128 30.6061 48.3333 30.6061C49.2538 30.6061 50 29.8599 50 28.9394V25.8333C50 22.6117 47.3883 20 44.1667 20H41.0607ZM23.3333 41.0607C23.3333 40.1402 22.5871 39.394 21.6667 39.394C20.7462 39.394 20 40.1402 20 41.0607V44.1667C20 47.3883 22.6117 50 25.8333 50H28.9394C29.8599 50 30.6061 49.2538 30.6061 48.3333C30.6061 47.4128 29.8599 46.6667 28.9394 46.6667H25.8333C24.4526 46.6667 23.3333 45.5473 23.3333 44.1667V41.0607ZM50 41.0607C50 40.1402 49.2538 39.394 48.3333 39.394C47.4128 39.394 46.6667 40.1402 46.6667 41.0607V44.1667C46.6667 45.5473 45.5473 46.6667 44.1667 46.6667H41.0607C40.1402 46.6667 39.394 47.4128 39.394 48.3333C39.394 49.2538 40.1402 50 41.0607 50H44.1667C47.3883 50 50 47.3883 50 44.1667V41.0607ZM28.3333 33.3333C27.4129 33.3333 26.6667 34.0795 26.6667 35C26.6667 35.9205 27.4129 36.6667 28.3333 36.6667H41.6667C42.5872 36.6667 43.3333 35.9205 43.3333 35C43.3333 34.0795 42.5872 33.3333 41.6667 33.3333H28.3333Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2141_25696"
          x1="34.5455"
          y1="2.70945e-07"
          x2="34.5455"
          y2="70"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#069476" />
          <stop offset="1" stop-color="#006C55" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default ScannerTypeAdminIconSubcategory
